import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { content: String };
  static targets = ["tooltip"];

  connect() {
    this.boundShow = this.show.bind(this);
    this.boundHide = this.hide.bind(this);
    this.element.addEventListener("mouseenter", this.boundShow);
    this.element.addEventListener("mouseleave", this.boundHide);
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.boundShow);
    this.element.removeEventListener("mouseleave", this.boundHide);
    this.removeTooltip();
  }

  show() {
    this.removeTooltip(); // Remove any existing tooltip

    const tooltip = document.createElement("div");
    tooltip.className =
      "absolute z-50 px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg whitespace-normal max-w-xs opacity-0";
    tooltip.innerHTML = this.contentValue;

    // Add to DOM first so we can measure it
    document.body.appendChild(tooltip);
    this.tooltip = tooltip;

    // Position the tooltip after it's in the DOM
    const rect = this.element.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft =
      window.pageXOffset || document.documentElement.scrollLeft;

    tooltip.style.top = `${rect.top + scrollTop - tooltipRect.height - 8}px`;
    tooltip.style.left = `${rect.left + scrollLeft + rect.width / 2}px`;
    tooltip.style.transform = "translateX(-50%)";
    tooltip.style.transition = "opacity 0.2s ease-in-out";

    // Show the tooltip
    setTimeout(() => {
      if (this.tooltip) {
        this.tooltip.style.opacity = "1";
      }
    }, 10);
  }

  hide() {
    this.removeTooltip();
  }

  removeTooltip() {
    if (this.tooltip) {
      this.tooltip.remove();
      this.tooltip = null;
    }
  }
}
